const leaveTransitionDurationMs = 150;
const wrapper = "dibw1d2rxep";
const indicator = "dibi114dvcv";

export { indicator, leaveTransitionDurationMs, wrapper };
import "./guide-bubble-with-animation.styles.linaria.module.css";
//# sourceMappingURL=guide-bubble-with-animation.styles.js.map
